/* Customer login */
class customerProfileLogin extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form')
      ? this.querySelector('form')
      : false
    this.password = this.form
      ? this.form.querySelector('input[name="customer[password]"]')
      : ''
    this.email = this.form
      ? this.form.querySelector('input[name="customer[email]"]')
      : ''
    this.firstName = this.form
      ? this.form.querySelector('input[name="customer[first_name]"]')
      : ''
    this.lastName = this.form
      ? this.form.querySelector('input[name="customer[last_name]"]')
      : ''

    this.accessToken = false;

    this.apiURL = 'https://' + Shopify.shop + '/api/' + '2023-01' + '/graphql.json';

    this.settings = {
      'async': true,
      'crossDomain': true,
      'method': 'POST',
      'headers': {
        'X-Shopify-Storefront-Access-Token': 'fa718d3883ebedf133390b1924fdcc6c',
        'Content-Type': 'application/graphql'
      }
    }
  }

  connectedCallback() {

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        /* Create access token after login */
        this.getCustomerAccessToken(this.email.value, this.password.value)

        e.target.submit();
      })
    }
  }

  /* STOREFRONT API: Retrieve access token */
  getCustomerAccessToken(email, pwd) {
    if (pwd) {

      let mutation = `mutation customerAccessTokenCreate {
      customerAccessTokenCreate(input: {email: "${email}", password: "${pwd}"}) {
        customerAccessToken {
          accessToken
        }
        customerUserErrors {
          message
        }
      }
    }`;

      this.settings.body = mutation

      fetch(this.apiURL, this.settings).then((res) => res.json()).then((result) => {

        if (result) {
          const accessToken = result
            .data
            .customerAccessTokenCreate
            .customerAccessToken
            .accessToken
          if (accessToken) {
            localStorage.setItem('profile_aT', accessToken)
            this.accessToken = accessToken
            if (document.querySelector('.save-profile')) {
              document.querySelector('.save-profile').classList.remove('disabled')
            }
          }
        }
      }).catch((error) => console.log(error))
    }
  }

  updateCustomerMetafields(customerDetails, redirect) {
    if (ravenObj) {
      const valueObj = {
        value: `${customerDetails}`
      };
      const requestParams = {
        raven: Object.assign({}, ravenObj, valueObj)
      };

      const response = fetch('/apps/raven/create_metafield', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestParams)
      })

      response.then(res => {
        if (res.status === 200) {

          // console.log('200', res.json)
          if (localStorage.getItem('c_profile')) {
            localStorage.removeItem('c_profile')
          }
          if (redirect) {
            window.location = window.routes.account_url
          }
        } else {

          // console.error('error', res.json)
          this.showError()
        }
      }).catch((error) => {
        console.log(error)
      });
    } else {
      this.showError();
      throw "RavenObj not found";
    }
  }

  showError(message = false) {

    // Create a div and add a class
    let messageWrapper = document.createElement("div");
    messageWrapper.className = "request-error py-[10px] error-message tinyBig text-[#CF3838]";
    if (message) {
      messageWrapper.innerText = message
        ? message
        : 'There was an erron on process this request. Please try in another moment'
    }


    if (message) {
      messageWrapper.innerText = message
    }

    if (this.form) {
      if (this.form.parentNode.querySelector('.request-error')) {
        this
          .form
          .parentNode
          .querySelector('.request-error')
          .remove()

      }

      // Insert the new node before the reference node
      this.form.parentNode.insertBefore(messageWrapper, this.form);
    }
  }
}

customElements.define('customer-profile-login', customerProfileLogin);


/* Customer account profile */
class customerProfile extends customerProfileLogin {
  constructor() {
    super();
    this.phone = this.form
      ? this.form.querySelector('input[name="customer[phone]"]')
      : ''
    this.gender = this.form
      ? this.form.querySelector('[name="customer[gender]"]')
      : ''
    this.birthdate = this.form
      ? this.form.querySelector('input[name="customer[birthdate]"]')
      : ''
  }

  connectedCallback() {
    const email = this.email
    if (localStorage.getItem('profile_aT')) {
      document.querySelector('.save-profile').classList.remove('disabled')
    } /* else if (localStorage.getItem('c_profile')) {
    const encodedString = localStorage.getItem('c_profile');
    const decodedString = atob(encodedString);
    const dataObj = JSON.parse(decodedString)
    // Create access token after login
    // this.getCustomerAccessToken(this.email.value, dataObj[0].p)
    } */
    if (this.form) {
      this.form.addEventListener('validation-submit', (e) => {
        let redirect = false;
        const firstName = this.firstName.value
        const lastName = this.lastName.value
        const phone = this.phone.value != ''
          ? this.phone.value
          : null
        const password = this.password.value

        const gender = this.gender.value != ''
          ? this.gender.value
          : null
        const birthdate = this.birthdate.value != ''
          ? this.birthdate.value
          : null

        // Customer data
        let customerData = {
          firstName: firstName,
          lastName: lastName,
          phone: phone,
          acceptsMarketing: false
        }

        // If change pwd logout and redirect to login
        if (password != '') {
          customerData.password = password
          redirect = true
        }

        // Customer metafields
        let customerDetails = [{
            gender: gender,
            birthdate: birthdate
          }]

        if (localStorage.getItem('profile_aT')) {
          const accessToken = localStorage.getItem('profile_aT')

          this.updateCustomer(JSON.stringify(customerData), customerDetails, accessToken, true)
        }
      })
    }
  }

  updateCustomer(data, customerDetails, accessToken, redirect) {
    let customerData = data.replace(/"([^(")"]+)":/g, "$1:");
    const language = Shopify.locale.toUpperCase()

    let mutation = `mutation @inContext(language: ${language}) {
      customerUpdate(customer: ${customerData}, customerAccessToken: "${accessToken}") {
        customerUserErrors {
          code
          field
          message
        }
      }
    }`;


    this.settings.body = mutation

    fetch(this.apiURL, this.settings).then((res) => res.json()).then((result) => {

      // Errors
      if (result.data.customerUpdate.customerUserErrors && result
          .data
          .customerUpdate
          .customerUserErrors
          .length > 0) {
        const errors = result.data.customerUpdate.customerUserErrors;
        errors.forEach(elem => {
          const input = document.querySelector('[name="customer[' + elem.field[1] + ']"]')
          if (input) {
            const errorMessage = input
              .parentElement
              .querySelector('.error-message')
              input
              .parentElement
              .classList
              .replace('input-field', 'input-field-err');
            input.parentElement.querySelector('.error-message').innerText = elem
              .message
              input
              .parentElement
              .querySelector('.error-message')
              .classList
              .remove('hidden')
          }
        })
      } else {
        this.updateCustomerMetafields(JSON.stringify(customerDetails), redirect)
      }
    }).catch((error) => console.log(error));
  }

}


customElements.define('customer-profile', customerProfile);

/* Registration page */
class customerProfileRegister extends customerProfileLogin {
  constructor() {
    super();
    this.gender = this.form.querySelector('[name="customer[note][gender]"]')
    this.birthdate = this.form.querySelector('input[name="customer[note][birthday]"]');
    this.marketing = this.form.querySelector('[name="customer[accepts_marketing]"]')
    this.returnTo = this.form.querySelector('[name="return_to"]')
  }

  connectedCallback() {

    /* Create access token after registration */
    this.form.addEventListener('validation-submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      let customerData = {
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        acceptsMarketing: this.marketing.checked,
        email: this.email.value,
        password: this.password.value
      }

      Shopify.mailupSubscribe(this.form, this.email.value, {
        'campo1': this.firstName.value,
        'campo2': this.lastName.value,
        'campo29': this.gender.value,
        'campo5': this.birthdate.value
      });

      //this.createCustomer(JSON.stringify(customerData))

    })
  }

  /* Create customer */
  createCustomer(data) {
    const self = this
    let customerData = data.replace(/"([^(")"]+)":/g, "$1:");
    const language = Shopify.locale.toUpperCase()

    let mutation = `mutation @inContext(language: ${language}) {
      customerCreate(input: ${customerData}) {
        customer {
          id
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }`;

    this.settings.body = mutation

    fetch(this.apiURL, this.settings).then((res) => res.json()).then((result) => {

      // Errors on fields
      if (result.data && result.data.customerCreate && result.data.customerCreate.customerUserErrors && result
          .data
          .customerCreate
          .customerUserErrors
          .length > 0) {

        const errors = result.data.customerCreate.customerUserErrors;

        errors.forEach(elem => {
          if (elem.field) {
            const input = document.querySelector('[name="customer[' + elem.field[1] + ']"]')
            if (input) {
              const errorMessage = input
                .parentElement
                .querySelector('.error-message')
                input
                .parentElement
                .classList
                .replace('input-field', 'input-field-err');
              input.parentElement.querySelector('.error-message').innerText = elem
                .message
                input
                .parentElement
                .querySelector('.error-message')
                .classList
                .remove('hidden')
            }
          } else {
            console.log(elem)
          }
        })
      } else if (result.errors) {
        result.errors.forEach(elem => {
          self.showError(elem.message)
        })

      } else {

        let customerId = false

        /* if (result.data && result.data.customerCreate && result.data.customerCreate.customer) {
        const resultData = result.data.customerCreate.customer
        
        const customerGlobalID = resultData.id
        const customerGlobalIDArr = customerGlobalID.split('/')
        customerId = customerGlobalIDArr.slice(-1)[0]
        } */

        this.saveCustomerData()

        // GA4
        pushOtherEvent("gaEvent", "account", "registration", undefined);
        if ($("#RegisterForm-newsletter").checked) {
          pushOtherEvent("gaEvent", "contact", "newsletter", "registration");
        }

        // GA4-END

        if (this.marketing.checked) {

          Shopify.mailupSubscribe(false, this.email.value, {
            'campo1': this.firstName.value,
            'campo2': this.lastName.value,
            'campo29': this.gender.value
          });
        }

        window.location = window.location.origin + this.returnTo.value
      }
    }).catch((error) => console.log(error));
  }

  saveCustomerData() {
    const data = [{
        g: this.gender.value,
        b: this.birthdate.value
      }]
    const encodedString = btoa(JSON.stringify(data))

    let customerDetails = [{
        "gender": this.gender.value,
        "birthdate": this.birthdate.value
      }]

    localStorage.setItem('c_profile', encodedString)
  }
}
customElements.define('customer-profile-register', customerProfileRegister);


/* After registration confirm */
class customerProfileConfirm extends customerProfileLogin {
  constructor() {
    super();
    this._updateCustomerProfile()
  }

  _updateCustomerProfile() {
    if (localStorage.getItem('c_profile')) {
      const encodedString = localStorage.getItem('c_profile');
      const decodedString = atob(encodedString);
      const dataObj = JSON.parse(decodedString)

      // Customer metafields
      let customerDetails = [{
          "gender": dataObj[0].g,
          "birthdate": dataObj[0].b
        }]

      this.updateCustomerMetafields(JSON.stringify(customerDetails), false)

    }
  }
}
customElements.define('customer-profile-confirm', customerProfileConfirm);